import script from "./Fd6ReportsDownload.vue?vue&type=script&setup=true&lang=js"
export * from "./Fd6ReportsDownload.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__